<div class="pre-approved-applicationwrap" *ngIf="business_info">
  <div class="row">
    <div class="col-lg-5" [ngClass]="{'false': collapse == true}">
      <div class="pre-approved-applicationwrap--leftside cols-wrap">
        <div class="pre-approved-applicationwrap--header">
          <div>
            <img src="assets\png\CredeeLogo.png" width="135px" alt="logo">
            <h4>Get Pre-Approved with Credee!</h4>
          </div>
          <div class="pre-approved-applicationwrap--rightside__header-closebtn left-mobileheader" *ngIf="is_iframe"
            (click)="closeIframe()">
            <span></span>
          </div>
        </div>
        <div class="pre-approved-applicationwrap--body">
          <h4>Get Pre-Approved with Credee!</h4>
          <p>We are here to help you obtain the services you need from {{business_info.business_name || (business_info.doctor_first_name +" "+
            business_info.doctor_last_name)}}.</p>
          <p>Credee is not a loan provider; it's a platform that empowers businesses to offer easy payment plans,
            promoting flexibility for customers while driving business growth for providers.</p>
          <p>Here are some of the top benefits of choosing Credee payment plans.</p>
          <div class="pre-approved-applicationwrap--cardwrap">
            <button 
              style="background: transparent;border: none;" class="custom-tooltip paddig-added">
              <div class="pre-approved-applicationwrap--cardwrap__inner">
                <div class="pre-approved-applicationwrap--cardwrap__inner-media bg-one">
                  <img src="assets/svg/no-credit-checks.svg" width="135px" alt="logo">
                </div>
                <div class="pre-approved-applicationwrap--cardwrap__inner-content">
                  <h6>Quick Process & Instant Approval</h6>
                  <p class="hove-content">No more lengthy waiting periods. Enjoy the convenience of instant approval, as Credee boasts a 100% approval rate.</p>
                </div>

              </div>
            </button>
            <button class="custom-tooltip" style="background: transparent;border: none;">
              <div class="pre-approved-applicationwrap--cardwrap__inner">
                <div class="pre-approved-applicationwrap--cardwrap__inner-media bg-two">
                  <img src="assets/svg/clarity-wallet-line.svg" width="135px" alt="logo">
                </div>
                <div class="pre-approved-applicationwrap--cardwrap__inner-content">
                  <h6>Flexible Payment Options To Fit Every Budget</h6>
                  <p class="hove-content">Credee allows businesses to create custom payment plans. So, you have the freedom to choose from a range of flexible payment options designed to align with your budget and financial goals.</p>
                </div>
              </div>
            </button>
            <button 
              class="custom-tooltip" style="background: transparent;border: none;">
              <div class="pre-approved-applicationwrap--cardwrap__inner">
                <div class="pre-approved-applicationwrap--cardwrap__inner-media bg-three">
                  <img src="assets/svg/percent-light.svg" width="135px" alt="logo">
                </div>
                <div class="pre-approved-applicationwrap--cardwrap__inner-content">
                  <h6>No Pre-Payment Penalties</h6>
                  <p class="hove-content">We know that many traditional financing providers often charge pre-payment fees, adding to the cost. However, with Credee, you can settle your balance early without any pre-payment penalties or unnecessary charges.</p>
                </div>
              </div>
            </button>
            <button 
              class="custom-tooltip" style="background: transparent;border: none;">
              <div class="pre-approved-applicationwrap--cardwrap__inner">
                <div class="pre-approved-applicationwrap--cardwrap__inner-media bg-four">
                  <img src="assets/svg/no-prepayment-penalties.svg" width="135px" alt="logo">
                </div>
                <div class="pre-approved-applicationwrap--cardwrap__inner-content">
                  <h6>Improve Credit Scores</h6>
                  <p class="hove-content">When you choose a Credee payment plan, you get to pay off via monthly payments that fit your budget easily, and timely payments help strengthen your payment history, positively impacting your credit scores.</p>
                </div>
              </div>
            </button>
          </div>
        </div>
        <div class="pre-approved-applicationwrap--footer">
          <div class="pre-approved-applicationwrap--footer__card">
            <div class="pre-approved-applicationwrap--footer__media">
              <img src="assets/svg/pre-application-improve.svg" width="135px" alt="logo">
            </div>
            <div class="pre-approved-applicationwrap--footer__content">
              <h5>Unlock a hassle-free payment experience!</h5>
            </div>
          </div>
          <div class="pre-approved-applicationwrap--footer__mobile-btn">
            <button (click)="apply()" class="btn">Apply Now</button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-7" [ngClass]="collapse == true ? 'desktop-collapse' : 'desktop'">
      <!-- <div class="congratulations_bar"
        *ngIf="approval_data && approval_data.application_data && approval_data.application_data[0] && approval_data.application_data[0].approved_amount && current_step != 5">
        <p><b>Congratulations!</b> You're preapproved for services up to <span class="colored notranslate">{{
            (currency_info && currency_info.display_logo) + approval_data.application_data[0].approved_amount}} </span>
          through Credee. <img src="assets\svg\icons.svg" alt="" class="pointer" (click)="download_reciept.show()"> </p>
      </div> -->
      <div class="pre-approved-applicationwrap--rightside" [class.full--height]="current_step == 5">
        <div class="pre-approved-applicationwrap--rightside__header" *ngIf="current_step != 4">
          <div class="pre-approved-applicationwrap--rightside__header-backbtn">
            <span (click)="stepback()" *ngIf="showbackbutton && current_step!=5" style="margin-top: 5px;">
              <span style="margin-right:6px"><svg xmlns="http://www.w3.org/2000/svg" width="7" height="14"
                  viewBox="0 0 7 14" fill="none">
                  <path d="M6 13L1.40683 8.06061C0.864388 7.47727 0.864389 6.52273 1.40683 5.93939L6 1" stroke="#596775"
                    stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </span>
              Back
            </span>
            <h3 *ngIf="current_step!=5"> Pre-Approval Application </h3>
          </div>
          <div class="pre-approved-applicationwrap--rightside__header-closebtn" *ngIf="is_iframe"
            (click)="closeIframe()">
            <span></span>
          </div>
          <!-- <div class="pre-approved-applicationwrap--rightside__header reload" *ngIf="!is_iframe" (click)="cleardata()">
            <span style="cursor: pointer;"> <img src="assets\svg\ic_round-refresh.svg" alt=""></span>
          </div> -->
        </div>
        <div class="pre-approved-applicationwrap--rightside__body">
          <div class="row justify-content-center m-0 p-1">
            <div class="application_input_container">
              <form class="pre-approved-applicationwrap--rightside__form" [formGroup]="preapproval_application_form">
                <div class="pre-approved-applicationwrap--rightside__form-stepone" *ngIf="current_step == 1"
                  formGroupName="first_page">
                  <h3>100% Pre-Approval Application</h3>
                  <p>What services are you interested in from <b>{{business_info.business_name}}? </b></p>
                  <div class="pre-approved-applicationwrap--rightside__innerform">
                    <div class="form-item ">
                      <input type="text" formControlName="service" appTrim
                        [ngClass]="invalid_input_class.first_page.service" id="serviceName"/>
                      <label>Services</label>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.first_page.service">Please enter a valid
                      Service Name.</p>
                  </div>

                  <div class="pre-approved-applicationwrap--rightside__formheading mt-1">
                    <h4>Personal Information</h4>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__innerform">
                    <div class="row px-3">
                      <div class="col-6 p-0 pe-2">
                        <div class="form-item">
                          <input type='text' formControlName="first_name" appTrim
                            [ngClass]="invalid_input_class.first_page.first_name" id="firstName"/>
                          <label>First Name</label>
                        </div>
                        <p class="invalid_text" [ngClass]="invalid_input_class.first_page.first_name">Please enter a
                          valid
                          First Name.</p>
                      </div>
                      <div class=" col-6 p-0 ps-2">
                        <div class="form-item">
                          <input type='text' formControlName="last_name" appTrim
                            [ngClass]="invalid_input_class.first_page.last_name" id="lastName"/>
                          <label>Last Name</label>
                        </div>
                        <p class="invalid_text" [ngClass]="invalid_input_class.first_page.last_name">Please enter a
                          valid
                          Last Name.</p>
                      </div>
                    </div>
                    <!-- gender -->
                    <div class="pre-approved-applicationwrap--rightside__employment-type justify-content-start  mb-3">
                      <div class="left-contentcard me-md-3">
                        <h5>
                          Gender:
                        </h5>
                      </div>
                      <div class="right-radiocard pt-0">
                        <div class="right-radiocard-inner"
                          (click)="preapproval_application_form.get('first_page').get('customer_gender').value!=1?preapproval_application_form.get('first_page').get('customer_gender').setValue(1):''">
                          <input type="radio" value="1"
                            [checked]="preapproval_application_form.get('first_page').get('customer_gender').value==1"
                            formControlName="customer_gender" id="one">
                          <label class="mb-0" id="one1"> <span>Male</span></label>
                        </div>
                        <div class="right-radiocard-inner"
                          (click)="preapproval_application_form.get('first_page').get('customer_gender').value!=2?preapproval_application_form.get('first_page').get('customer_gender').setValue(2):''">
                          <input type="radio" value="2"
                            [checked]="preapproval_application_form.get('first_page').get('customer_gender').value==2"
                            formControlName="customer_gender" id="two">
                          <label class="mb-0" id="two1"> <span>Female</span></label>
                        </div>
                        <div class="right-radiocard-inner"
                          (click)="preapproval_application_form.get('first_page').get('customer_gender').value!=3?preapproval_application_form.get('first_page').get('customer_gender').setValue(3):''">
                          <input type="radio" value="3"
                            [checked]="preapproval_application_form.get('first_page').get('customer_gender').value==3"
                            formControlName="customer_gender" id="three">
                          <label class="mb-0" id="three1"> <span>Others</span></label>
                        </div>
                      </div>
                    </div>

                    <div class="row m-0 mb-4">
                      <div class="col-md-2 m-0 p-0">
                        <select class="form-select select_class" aria-label="Default select example" disabled>
                          <option value="1">{{country_info && country_info.mobile_code}}</option>
                        </select>
                      </div>
                      <div class="form-item col-md-10 p-0">
                        <input type="text" formControlName="mobile" [mask]="mask" [validation]="false" [maxlength]='phone_length' [minlength]="min_phone_length" [ngClass]="invalid_input_class.first_page.mobile" aria-label="Phone Input" id="phoneNo">
                        <label for="mobile">Phone</label>
                      </div>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.first_page.mobile">Please enter a valid Phone
                      Number.
                    </p>
                    <!-- email -->
                    <div class="form-item">
                      <input type='text' formControlName="email" [ngClass]="invalid_input_class.first_page.email" id="email1"/>
                      <label>Email</label>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.first_page.email">Please enter a valid Email.
                    </p>

                    <div class="form-item textareaouter" [ngClass]="invalid_input_class.first_page.time_to_contact">
                      <textarea appTrim formControlName="time_to_contact" id="bestcontact"></textarea>
                      <label class="position_on_top">Best time to contact you </label>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.first_page.time_to_contact">Please enter a
                      valid Best time to contact
                    </p>

                  </div>
                  <!-- step-1 -->
                  <div class="pre-approved-applicationwrap--rightside__formbtn">
                    <button class="btn continue " [disabled]="!preapproval_application_form.get('first_page').valid"
                      type="button" #continue (click)="customerDetailsCheckPhone();">
                      <span id="leadContinue1">Continue</span></button>
                  </div>
                </div>

                <div class="pre-approved-applicationwrap--rightside__form-steptwo" *ngIf="current_step == 2"
                  formGroupName="second_page">
                  <div class="pre-approved-applicationwrap--rightside__formheading mt-1 mb-4">
                    <h3 class="bolder fw-500">Personal information (Recommended)</h3>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__innerform">
                    <div class="form-item">
                      <!-- current key , key value to change -->
                      <input [type]="hidessn ? 'Password':'text'" formControlName="ssn" appTrim
                        [ngClass]="invalid_input_class.second_page.ssn" [class.has-errors]="dateError"
                        *ngIf="country_info && country_info.original_identity_label != 'SSN/EIN'" [minlength]="mainService.minDocumentIdLength" [maxlength]="mainService.maxDocumentIdLength" (input)="alphabet($event)" (blur)="alphabet($event)" id="ssn1">

                      <input *ngIf="country_info && country_info.original_identity_label == 'SSN/EIN'"
                        [type]="hidessn ? 'Password':'text'" formControlName="ssn"
                        onKeyPress="if(this.value.length==9) return false;" (ngModelChange)="validate_ssn()"
                        [ngClass]="invalid_input_class.second_page.ssn" id="ssn1">
                      <!-- <label>{{country_info && country_info.original_identity_label}}</label> -->
                      <label>{{mainService.document_label}}</label>
                      <button type="button" class="d-inline me-2 eye_style" [ngClass]="hidessn ? 'closed_eye' :
                      'open_eye'" (click)="hidessn = !hidessn">
                      </button>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.second_page.ssn" *ngIf="!dateError">Please enter a valid
                      {{country_info && country_info.original_identity_label}}.</p>
                    <p class="invalid_text has-error" *ngIf="dateError">Please enter a valid
                      {{country_info && country_info.original_identity_label}}.</p>
                    <div class="d-flex align-items-center">
                      <div class="form-item col-12 d-flex align-items-center">
                        <input [type]="hidedl ? 'Password':'text'" formControlName="dl_number" (keypress)="changeDLValue($event)" appTrim
                          autocomplete="disabled" [ngClass]="invalid_input_class.second_page.dl_number" (input)="regexCheck($event)"
                          [maxlength]="regexMode && regexMode.max" [minlength]="regexMode && regexMode.min" id="dl1" />
                        <label>Government-Issued ID Number</label>
                        <button type="button" class="d-inline me-2 eye_style" [ngClass]="hidedl ? 'closed_eye' :
                                            'open_eye'" (click)="hidedl = !hidedl">
                        </button>
                      </div>
                      <span class="ms-2 mb-3"
                        [tooltip]="'Number from your government-issued ID, such as a Driver’s License, Passport, or any official identification document.'"
                        [customClass]="'dark-theme-tooltip'" [placement]="'right'">
                        <img src="assets/svg/icons.svg" class="" alt="info icon">
                      </span>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.second_page.dl_number" *ngIf="!dateErrors">Please enter a valid
                      Government-Issued ID Number.</p>
                      <p class="invalid_text has-error" *ngIf="dateErrors">Please enter a valid
                        Government-Issued ID Number.</p>
                    <div class="form-item">
                      <!-- <input formControlName="date_of_birth" class="-pointer input_field pt-3 dob-input-field ps-3"
                        type="text" appDob [ngClass]="invalid_input_class.second_page.date_of_birth"
                        autocomplete="off" /> -->
                      <input (blur)="blurDataUpdate($event)" name="date_of_birth" id="element"
                        class="-pointer input_field pt-3 dob-input-field ps-3" type="text"
                        formControlName="date_of_birth" mask="{{dateOfBirthMask}}" dropSpecialCharacters="true"
                        [specialCharacters]=specialCharacter required [ngClass]="invalid_input_class.second_page.date_of_birth"
                        autocomplete="off" (input)="addZero($event)" (keydown)="handleKeyDown($event)"
                        (mousedown)="handleMouseDown($event)" (click)="handleMouseDown($event)" />
                      <label>Date of Birth {{placeFormat}}</label>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.second_page.date_of_birth">Please enter a
                      valid date of birth.</p>
                      <div *ngIf="showGoogleApi" class="form-item">
                        <app-google-api (setAddress)="getZipselected($event,1)" [t]="1" [customClass]="['custom-form-v5']"
                          [isRequired]="true" id="zipPostalCode" name="zipPostalCode"
                          [invalid_input_class]="invalid_input_class.second_page.address"
                          [model]="preapproval_application_form.get('second_page').get('address').value" ngDefaultControl
                          label="Address*" [addressDetails]="this.zip_obj['user_data']" [editAddressManually]="editAddressManually"
                          [defaultzip]="preapproval_application_form.get('second_page').get('zip').value" zipcodeNull="arDetail">
                        </app-google-api>
                      </div>
                      <p class="invalid_text" [ngClass]="invalid_input_class.second_page.address">Please enter a valid
                        address.</p>


                        <div class="form-item">
                          <input type='text' formControlName="address_2" autocomplete="__away" appTrim
                            [ngClass]="invalid_input_class.second_page.address_2" />
                          <label>Address Line 2 (Optional)
                          </label>
                        </div>
                    <div class="form-item">
                      <input type='text' formControlName="zip" autocomplete="__away" appTrim (blur)="editAddressManually = true; getZipselected({edit_address_manually: true}, 1)"
                        [ngClass]="invalid_input_class.second_page.zip" maxlength="8"/>
                      <label>Zip/Postal Code</label>
                    </div>
                    <p class="invalid_text" [ngClass]="invalid_input_class.second_page.zip">Please enter a valid
                      Zip/Postal Code.</p>

                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-item">
                          <input type='text' formControlName="city" autocomplete="__away" appTrim appAlphabetsOnly maxlength="30"
                            [ngClass]="invalid_input_class.second_page.city" id="city1" (blur)="editAddressManually = true; getZipselected({edit_address_manually: true}, 1)"/>
                          <label>City</label>
                        </div>
                        <p class="invalid_text" [ngClass]="invalid_input_class.second_page.city">Please enter a valid
                          City.</p>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-item" [ngClass]="{'select-wrapper': showDropDown}">
                          @if(showDropDown) {
                            <select name="state" id="state1" formControlName="state_code" (change)="stateSelected(preapproval_application_form.get('second_page').get('state_code').value, 'second_page')">
                              <option *ngFor="let state of country_states" [value]="state.state_code">{{state.state_name}}</option>
                            </select>
                          } @else {
                            <input type='text' formControlName="state" autocomplete="__away" id="state1" disabled />
                          }
                          <label>State</label>
                        </div>
                      </div>
                    </div>
                    <div class="id-proof">
                      <h4>Proof Of ID (Recommended)</h4>
                      <div class="id-proof-inner" *ngIf="!doc_local_url">
                        <div class="id-proof-input">
                          <input accept="image/*,.pdf" type="file" (change)="fileChangeEvent($event)">
                          <label>Choose</label>
                        </div>
                        <div class="id-proof-content">
                          <p>Upload Driver’s License or any government-issued proof of ID.</p>
                        </div>
                      </div>
                      <div *ngIf="doc_local_url" class="view_documents">
                        <span style="font-size: 13px" (click)="view_docs(doc_local_url)">
                          <img src="assets/svg/document-icon.svg" class="pe-3" alt="">Proof of ID</span>

                        <img src="assets/svg/delete-icon.svg" (click)="delete_docs()" class="pointer" alt="" />

                      </div>
                    </div>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__formbtn">
                    <button class="btn continue" #continue1
                      [disabled]="!preapproval_application_form.get('second_page').valid"
                      (click)="submit_data();continue1.blur();is_same_addres=false">
                      <span id="leadContinue2">Continue</span></button>
                    <button class="btn skip" #skip1 [disabled]="preapproval_application_form.get('second_page').valid" (click)="submit_data(1);skip1.blur();is_same_addres=false">
                      Skip</button>
                  </div>
                </div>

                <div class="pre-approved-applicationwrap--rightside__form-stepthree" *ngIf="current_step == 3"
                  formGroupName="third_employement_page">
                  <div class="pre-approved-applicationwrap--rightside__formheading mt-1">
                    <h4>Employment Information</h4>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__employment-type">
                    <div class="left-contentcard">
                      <h5>
                        Are you Employed?
                      </h5>
                    </div>
                    <div class="right-radiocard">
                      <div class="right-radiocard-inner" (click)="select_emp_type(1)">
                        <input type="radio" value="1" [checked]="employement_type.value==1"
                          formControlName="employement_type" id="yes1">
                        <label id="yes2"> <span>Yes</span></label>
                      </div>
                      <div class="right-radiocard-inner" (click)="select_emp_type(2)">
                        <input type="radio" value="2" [checked]="employement_type.value==2"
                          formControlName="employement_type" id="no1">
                        <label id="no2"> <span>No</span></label>
                      </div>
                      <div class="right-radiocard-inner" (click)="select_emp_type(3)">
                        <input type="radio" value="3" [checked]="employement_type.value==3"
                          formControlName="employement_type" id="self1">
                        <label id="self2"> <span>Self Employed</span></label>
                      </div>
                    </div>

                  </div>
                  <div class="pre-approved-applicationwrap--rightside__formbtn"
                    *ngIf="!(employement_type.value==1 || employement_type.value==2 || employement_type.value==3) ">
                    <button class="btn continue" #continue2 [disabled]="true"
                      (click)="submit_data();continue2.blur();"><span id="leadContinue3">Submit</span></button>
                    <button class="btn skip" #skip2 (click)="submit_data(1);skip2.blur();" id="leadContinue4">
                      Skip</button>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__innerform" formGroupName="employeed"
                    *ngIf="employement_type.value==1">
                    <div class="form-item">
                      <input type='text' formControlName="employer_name" appTrim
                        [ngClass]="invalid_input_class.third_employement_page.employeed.employer_name" id="employName"/>
                      <label>Employer Name</label>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.employeed.employer_name">Please enter a
                      valid Employer Name.</p>
                    <div class="row m-0 p-0">
                      <div class="col-md-2 m-0 p-0">
                        <select class="form-select select_class" aria-label="Default select example" disabled>
                          <option value="1">{{country_info && country_info.mobile_code}}</option>
                        </select>
                      </div>
                      <div class="form-item col-md-10 p-0">
                        <input type="text" formControlName="employer_mobile"
                          [ngClass]="invalid_input_class.third_employement_page.employeed.employer_mobile" [mask]="mask"
                          [validation]="false" [maxlength]='phone_length' [minlength]="min_phone_length" id="employNo">
                        <label>Employer Phone Number</label>
                      </div>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.employeed.employer_mobile">Please enter a
                      valid Employer Phone Number.</p>
                      <div class="form-item" *ngIf="this.mainService?.currency_data?.country_code">
                        <app-google-api (setAddress)="getZipselected($event,2)" [t]="1" [customClass]="['custom-form-v5']"
                          [isRequired]="true" id="zipPostalCode" name="zipPostalCode"
                          [invalid_input_class]="invalid_input_class.third_employement_page.employeed.employer_address"
                          [model]="preapproval_application_form.get('third_employement_page').get('employeed').get('employer_address').value"
                          ngDefaultControl label="Employer Address*" [addressDetails]="this.zip_obj['employed_data']" [editAddressManually]="editEmployerAddressManually"
                          [defaultzip]="preapproval_application_form.get('third_employement_page').get('employeed').get('employer_zip').value" zipcodeNull="arDetail">
                        </app-google-api>
                        <p class="invalid_text mt-0"
                      [ngClass]="invalid_input_class.third_employement_page.employeed.employer_address">Please enter a valid
                      Address.</p>
                      </div>
                      <div class="form-item">
                        <input type='text' formControlName="employer_address_2" appTrim
                          [ngClass]="invalid_input_class.third_employement_page.employeed.employer_address_2" id="employer_address_2"/>
                        <label>Employer Address Line 2 (Optional)</label>
                      </div>
                    <div class="form-item">
                      <input type='text' formControlName="employer_zip" appTrim autocomplete="__away" (blur)="editEmployerAddressManually = true; getZipselected({edit_address_manually: true}, 2)"
                        [ngClass]="invalid_input_class.third_employement_page.employeed.employer_zip" maxlength="8"/>
                      <label>Employer Zip/Postal Code*</label>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.employeed.employer_zip">Please enter a
                      valid zip/postal code.</p>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-item">
                          <input appAlphabetsOnly type='text' formControlName="employer_city" (blur)="editEmployerAddressManually = true; getZipselected({edit_address_manually: true}, 2)"
                            [ngClass]="invalid_input_class.third_employement_page.employeed.employer_city" id="employCity" maxlength="30"/>
                          <label>City</label>
                        </div>
                        <p class="invalid_text"
                          [ngClass]="invalid_input_class.third_employement_page.employeed.employer_city">Please enter a
                          valid City.</p>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-item" [ngClass]="{'select-wrapper': showDropDown}">
                          @if(showDropDown) {
                            <select name="state" id="empState" formControlName="employer_state_code" (change)="stateSelected(preapproval_application_form.get('third_employement_page').get('employeed').get('employer_state_code').value, 'third_employement_page', 'employeed')">
                              <option *ngFor="let state of country_states" [value]="state.state_code">{{state.state_name}}</option>
                            </select>
                          } @else {
                            <input type='text' formControlName="employer_state" autocomplete="__away" id="empState" disabled />
                          }
                          <label>State</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-item">
                      <span
                        *ngIf="preapproval_application_form.get('third_employement_page.employeed.annual_income').value"
                        style="position: absolute;top: 22px;left: 15px;">
                        {{currency_info && currency_info.display_logo}}
                      </span>
                      <input type='text' formControlName="annual_income" appTrim appDecimaNumber
                        [ngClass]="invalid_input_class.third_employement_page.employeed.annual_income"
                        [ngStyle]="{'padding-left': currency_info && currency_info.display_logo && currency_info.display_logo.length == 1 ? '35px' : '3rem'}"
                        (keypress)="enterNumberOnly($event)" maxlength="7"
                        onKeyPress="if(this.value.length==7) return false;" id="annualIncomne"/>
                      <label>Annual Income</label>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.employeed.annual_income">Please enter your
                      Annual Income</p>
                    <div class="pre-approved-applicationwrap--rightside__formbtn">
                      <button class="btn continue" #continue2
                        [disabled]="!preapproval_application_form.get('third_employement_page').get('employeed').valid"
                        (click)="submit_data();continue2.blur();"><span id="leadContinue5">Submit</span></button>
                      <button class="btn skip" [disabled]="preapproval_application_form.get('third_employement_page').get('employeed').valid" id="leadContinue6" #skip2 (click)="submit_data(1);skip2.blur();">
                        Skip</button>
                    </div>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__innerform" formGroupName="unemployeed"
                    *ngIf="employement_type.value==2">
                    <div action="" class="form-item select-wrapper">
                      <select formControlName="payback_methods"
                        [ngClass]="invalid_input_class.third_employement_page.unemployeed.payback_methods"
                        (change)="change_pay_back_method()" id="familyMate">
                        <option value="Family"> Family </option>
                        <option value="Guardian">Guardian</option>
                        <option value="Siblings">Siblings</option>
                        <option value="Spouse">Spouse</option>
                        <option value="Acquaintance">Acquaintance</option>
                        <option value="Social Security Benefits">Social Security Benefits</option>
                        <option value="Crowdfunding/Fundraising">Crowdfunding/Fundraising</option>
                        <option value="Other">Other</option>
                      </select>
                      <label for="person">Please select your payment source</label>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.unemployeed.payback_methods">Please Choose a
                      valid Payback Source</p>
                    <div class="form-item"
                      *ngIf="preapproval_application_form.get('third_employement_page').get('unemployeed').get('payback_methods').value=='Other'">
                      <input type='text' formControlName="other_payback_method" appTrim
                        [ngClass]="invalid_input_class.third_employement_page.unemployeed.other_payback_method" id="PaymentSource" />
                      <label>Payment Source Name</label>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.unemployeed.other_payback_method">Please
                      enter valid payback source.</p>
                    <div class="pre-approved-applicationwrap--rightside__formbtn">
                      <button class="btn continue" #continue3
                        [disabled]="!preapproval_application_form.get('third_employement_page').get('unemployeed').valid"
                        (click)="submit_data();continue3.blur()"><span id="leadContinue7">Submit</span></button>
                      <button class="btn skip" #skip3 [disabled]="preapproval_application_form.get('third_employement_page').get('unemployeed').valid" (click)="submit_data(1);skip3.blur()" id="leadContinue8">
                        Skip</button>
                    </div>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__innerform self-employed"
                    formGroupName="self_employeed" *ngIf="employement_type.value==3">
                    <div class="form-item">
                      <input type='text' formControlName="profession" appTrim
                        [ngClass]="invalid_input_class.third_employement_page.self_employeed.profession" id="profession1"/>
                      <label>Profession</label>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.self_employeed.profession">Please enter a
                      valid Profession.</p>
                      <div class="form-item" *ngIf="this.mainService?.currency_data?.country_code">
                        <app-google-api (setAddress)="getZipselected($event,3)" [t]="1" [customClass]="['custom-form-v5']"
                          [isRequired]="true" id="zipPostalCode" name="zipPostalCode"
                          [invalid_input_class]="invalid_input_class.third_employement_page.self_employeed.office_address"
                          [model]="preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_address').value"
                          ngDefaultControl label="Office Address*" [addressDetails]="this.zip_obj['office_data']" [editAddressManually]="editOfficeAddressManually"
                          [defaultzip]="preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_zip').value" zipcodeNull="arDetail">
                        </app-google-api>
                        <p class="invalid_text mt-0"
                      [ngClass]="invalid_input_class.third_employement_page.self_employeed.office_address">Please enter a
                      valid address.</p>
                      </div>
                      <div class="form-item">
                        <input type='text' formControlName="office_address_2" appTrim
                          [ngClass]="invalid_input_class.third_employement_page.self_employeed.office_address_2" id="office_address_2"/>
                        <label>Office Address Line 2 (Optional)</label>
                      </div>
                      <div class="form-item checkbox-iteam" (click)="same_address_toggle()">
                        <input type="checkbox" [checked]="is_same_addres">
                        <h6>Office Address Same as Home Address</h6>
                      </div>
                      <div class="form-item">
                        <input type='text' formControlName="office_zip" autocomplete="__away" appTrim (blur)="editOfficeAddressManually = true; getZipselected({edit_address_manually: true}, 3)"
                          [ngClass]="invalid_input_class.third_employement_page.self_employeed.office_zip" maxlength="8"/>
                        <label>Office Zip/Postal Code*</label>
                      </div>
                      <p class="invalid_text"
                        [ngClass]="invalid_input_class.third_employement_page.self_employeed.office_zip">Please
                        enter valid office zip/postal code.</p>
                    <div class="row">
                      <div class="col-lg-6">
                        <div class="form-item">

                          <input appAlphabetsOnly [ngClass]="invalid_input_class.third_employement_page.self_employeed.office_city"
                            type='text' formControlName="office_city" id="officeCity" (blur)="editOfficeAddressManually = true; getZipselected({edit_address_manually: true}, 3)" maxlength="30" />
                          <label>City</label>
                        </div>
                        <p class="invalid_text"
                          [ngClass]="invalid_input_class.third_employement_page.self_employeed.office_city">Please
                          enter valid city.</p>
                      </div>
                      <div class="col-lg-6">
                        <div class="form-item" [ngClass]="{'select-wrapper': showDropDown}">
                          @if(showDropDown) {
                            <select name="state" id="officeState" formControlName="office_state_code" (change)="stateSelected(preapproval_application_form.get('third_employement_page').get('self_employeed').get('office_state_code').value, 'third_employement_page', 'self_employeed')">
                              <option *ngFor="let state of country_states" [value]="state.state_code">{{state.state_name}}</option>
                            </select>
                          } @else {
                            <input type='text' formControlName="office_state" autocomplete="__away" id="officeState" disabled />
                          }
                          <label>State</label>
                        </div>
                      </div>
                    </div>
                    <div class="form-item">
                      <span
                        *ngIf="preapproval_application_form.get('third_employement_page.self_employeed.annual_income').value"
                        style="position: absolute;top: 22px;left: 15px;">
                        {{currency_info && currency_info.display_logo}}
                      </span>
                      <input type='text' formControlName="annual_income" appTrim appDecimaNumber
                        [ngClass]="invalid_input_class.third_employement_page.self_employeed.annual_income"
                        [ngStyle]="{'padding-left': currency_info && currency_info.display_logo && currency_info.display_logo.length == 1 ? '35px' : '3rem'}"
                        (keypress)="enterNumberOnly($event)" maxlength="7"
                        onKeyPress="if(this.value.length==7) return false;" id="annualIncome2"/>
                      <label>Annual Income</label>
                    </div>
                    <p class="invalid_text"
                      [ngClass]="invalid_input_class.third_employement_page.self_employeed.annual_income">Please enter
                      your Annual Income</p>
                    <div class="pre-approved-applicationwrap--rightside__formbtn">
                      <button class="btn continue" #continue4
                        [disabled]="!preapproval_application_form.get('third_employement_page').get('self_employeed').valid"
                        (click)="submit_data();continue4.blur()"><span id="leadContinue9">Submit</span></button>
                      <button class="btn skip" #skip4 [disabled]="preapproval_application_form.get('third_employement_page').get('self_employeed').valid" id="leadContinue10" (click)="submit_data(1);skip4.blur();">
                        Skip</button>
                    </div>
                  </div>
                </div>
              </form>
              <div class="pre-approved-applicationwrap--rightside__form-stepfour"
                [ngClass]="{'d-none': current_step != 4}">
                <img src="assets/svg/verifying-loader.gif" width="135px" alt="pre-application-verifying"
                  style="box-shadow: 7px 7px 78px 39px white; ">
                <h3>Verifying Details</h3>
              </div>
              <div class="pre-approved-applicationwrap--rightside__form-stepfive" *ngIf="current_step == 5">
                <div class="pre-approved-applicationwrap--rightside__congratulations">
                  <div class="pre-approved-applicationwrap--rightside__congratulations-media">
                    <img src="assets/svg/check_success.svg" alt="check success" style="max-width: 45px;width: 100%;">
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__congratulations-content">
                    <h3>Congratulations!</h3>
                    <p>You have been Pre-Approved for a Credee payment plan up to:</p>
                    <h4 class="notranslate"> {{ (currency_info && currency_info.display_logo) +
                      approval_data.application_data[0].approved_amount}}</h4>
                  </div>
                </div>
                <div class="pre-approved-applicationwrap--rightside__detailcard ">
                  <div class="pre-approved-applicationwrap--rightside__detailcard-rightcontent">
                    <h5>Application ID</h5>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__detailcard-leftcontent">
                    <div class="btn-grp dotted_border">
                      <p class="value-btn">{{approval_data.application_data[0].application_id}}
                      </p>
                      <span class="pointer" (click)="copy(approval_data.application_data[0].application_id)"><svg
                          xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path
                            d="M9.2474 18.9587H5.7474C2.48906 18.9587 1.03906 17.5087 1.03906 14.2503V10.7503C1.03906 7.49199 2.48906 6.04199 5.7474 6.04199H9.2474C12.5057 6.04199 13.9557 7.49199 13.9557 10.7503V14.2503C13.9557 17.5087 12.5057 18.9587 9.2474 18.9587ZM5.7474 7.29199C3.16406 7.29199 2.28906 8.16699 2.28906 10.7503V14.2503C2.28906 16.8337 3.16406 17.7087 5.7474 17.7087H9.2474C11.8307 17.7087 12.7057 16.8337 12.7057 14.2503V10.7503C12.7057 8.16699 11.8307 7.29199 9.2474 7.29199H5.7474Z"
                            fill="#1581E5" />
                          <path
                            d="M14.2474 13.9587H13.3307C12.9891 13.9587 12.7057 13.6753 12.7057 13.3337V10.7503C12.7057 8.16699 11.8307 7.29199 9.2474 7.29199H6.66406C6.3224 7.29199 6.03906 7.00866 6.03906 6.66699V5.75033C6.03906 2.49199 7.48906 1.04199 10.7474 1.04199H14.2474C17.5057 1.04199 18.9557 2.49199 18.9557 5.75033V9.25033C18.9557 12.5087 17.5057 13.9587 14.2474 13.9587ZM13.9557 12.7087H14.2474C16.8307 12.7087 17.7057 11.8337 17.7057 9.25033V5.75033C17.7057 3.16699 16.8307 2.29199 14.2474 2.29199H10.7474C8.16406 2.29199 7.28906 3.16699 7.28906 5.75033V6.04199H9.2474C12.5057 6.04199 13.9557 7.49199 13.9557 10.7503V12.7087Z"
                            fill="#1581E5" />
                        </svg></span>
                    </div>
                  </div>
                </div>
                <div class="pre-approved-applicationwrap--rightside__btncard">
                  <a (click)="download_lead_reciept()" class="download_pdf_btn">
                    <button class="pdf-btn btn" id="download1">
                      <span><img src="assets/svg/download_icon.svg"></span> Download PDF
                    </button></a>
                  <button class="emailcopy-btn btn" (click)="send_application_receipt()"><span><svg
                        xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                        <path d="M6 5L11 8.5L16 5" stroke="#1581E5" stroke-width="1.5" stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M1 13V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H19C19.5304 1 20.0391 1.21071 20.4142 1.58579C20.7893 1.96086 21 2.46957 21 3V13C21 13.5304 20.7893 14.0391 20.4142 14.4142C20.0391 14.7893 19.5304 15 19 15H3C2.46957 15 1.96086 14.7893 1.58579 14.4142C1.21071 14.0391 1 13.5304 1 13Z"
                          stroke="#1581E5" stroke-width="1.5" />
                      </svg></span>  Text me
                  </button>
                </div>
                <div class="pre-approved-applicationwrap--rightside__contentcard mt-5">
                  <h4 class="mb-3"> <img src="assets/svg/Question.svg" style="width:20px;margin-top:-3px;" alt="logo">
                    What’s next</h4>
                  <p> <strong>
                    {{(business_info && business_info.practice_name) ? business_info.practice_name : (business_info.doctor_first_name +" " +
                    business_info.doctor_last_name)}}
                  </strong> is excited to offer you top-notch services
                    with an exceptional payment experience. You can get started by choosing the services that best fit your needs. If you
                    are ready to take the next step, feel free to reach out at <strong>{{(business_info && business_info.practice_email) ? business_info.practice_email : business_info.doctor_email}}</strong> or give them
                    a call at <strong>{{ country_info && country_info.mobile_code === '+1' ? '' : (country_info && country_info.mobile_code)
                      + '-' }}{{business_info.practice_mobile ?business_info.practice_mobile :business_info.doctor_mobile}}</strong>.
                  </p>
                  <!-- <p>Now, it's time to take the next step—reach out directly to the business. Seize the opportunity and
                    make that connection. You're one step closer to making your desired service(s) a reality!</p> -->
                </div>
                <!-- <div class="pre-approved-applicationwrap--rightside__detailcard contact business_info">
                  <div class="pre-approved-applicationwrap--rightside__detailcard-rightcontent ">
                    <h6>Business Contact Details:</h6>
                    <p class="contact-mail mb-0">
                      <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12"
                          fill="none">
                          <path d="M4.57227 3.85742L8.14369 6.35742L11.7151 3.85742" stroke="#1581E5"
                            stroke-width="1.07143" stroke-linecap="round" stroke-linejoin="round" />
                          <path
                            d="M1 9.57143V2.42857C1 2.04969 1.15051 1.68633 1.41842 1.41842C1.68633 1.15051 2.04969 1 2.42857 1H13.8571C14.236 1 14.5994 1.15051 14.8673 1.41842C15.1352 1.68633 15.2857 2.04969 15.2857 2.42857V9.57143C15.2857 9.95031 15.1352 10.3137 14.8673 10.5816C14.5994 10.8495 14.236 11 13.8571 11H2.42857C2.04969 11 1.68633 10.8495 1.41842 10.5816C1.15051 10.3137 1 9.95031 1 9.57143Z"
                            stroke="#1581E5" stroke-width="1.07143" />
                        </svg></span>{{business_info.business_email}}
                    </p>
                  </div>
                  <div class="pre-approved-applicationwrap--rightside__detailcard-leftcontent">
                    <div class="btn-grp">
                      <p class="contact-num mb-0">
                        <span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"
                            fill="none">
                            <path
                              d="M4.70484 1.61187L5.48284 1.37787C5.90904 1.24936 6.36743 1.28029 6.77249 1.46491C7.17755 1.64953 7.5016 1.97522 7.68418 2.38121L8.28551 3.71854C8.44249 4.06774 8.4862 4.45732 8.41052 4.83263C8.33483 5.20794 8.14355 5.55013 7.86351 5.81121L6.86684 6.73987C6.83773 6.767 6.81928 6.80366 6.81484 6.84321C6.78551 7.10787 6.96484 7.62321 7.37884 8.33987C7.67884 8.86054 7.95151 9.22654 8.18284 9.43121C8.34484 9.57454 8.43351 9.60521 8.47151 9.59454L9.81151 9.18454C10.1774 9.07261 10.5692 9.07799 10.932 9.19994C11.2947 9.32188 11.6102 9.55427 11.8342 9.86454L12.6875 11.0485C12.9473 11.4085 13.0676 11.8505 13.0262 12.2925C12.9848 12.7345 12.7843 13.1465 12.4622 13.4519L11.8708 14.0119C11.5574 14.3087 11.1723 14.5194 10.7533 14.6232C10.3342 14.7271 9.89535 14.7207 9.47951 14.6045C7.64351 14.0919 5.99751 12.5425 4.52284 9.98854C3.04684 7.43121 2.52818 5.22854 3.00684 3.37987C3.11429 2.9641 3.32703 2.58301 3.62456 2.27334C3.92208 1.96367 4.29369 1.73586 4.70484 1.61187ZM4.99351 2.56987C4.74677 2.64408 4.5233 2.78059 4.34465 2.96625C4.16599 3.15191 4.03817 3.38046 3.97351 3.62987C3.57218 5.18454 4.03151 7.13721 5.38884 9.48854C6.74484 11.8365 8.20418 13.2099 9.74884 13.6419C9.99836 13.7115 10.2617 13.7153 10.5131 13.6529C10.7645 13.5905 10.9955 13.464 11.1835 13.2859L11.7742 12.7259C11.9207 12.5871 12.0119 12.3998 12.0308 12.1988C12.0497 11.9979 11.995 11.7969 11.8768 11.6332L11.0235 10.4499C10.9217 10.3087 10.7782 10.2029 10.6132 10.1474C10.4482 10.092 10.27 10.0895 10.1035 10.1405L8.76018 10.5519C7.98018 10.7839 7.27284 10.1565 6.51284 8.83987C6.00018 7.95321 5.76151 7.26654 5.82151 6.73254C5.85218 6.45521 5.98151 6.19921 6.18484 6.00854L7.18151 5.07987C7.30875 4.96114 7.39562 4.80555 7.42993 4.63493C7.46424 4.46431 7.44428 4.28723 7.37284 4.12854L6.77218 2.79121C6.68917 2.60667 6.54186 2.45863 6.35773 2.37472C6.1736 2.29081 5.96523 2.27677 5.77151 2.33521L4.99351 2.56987Z"
                              fill="#1581E5" />
                          </svg></span>
                        {{(country_info && country_info.mobile_code)+"-"+business_info.business_mobile}}
                      </p>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div bsModal #download_reciept="bs-modal" [config]="{ignoreBackdropClick:false, keyboard : false}" data-keyboard="false"
  data-backdrop="static" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
  aria-hidden="true">
  <div class="modal-dialog    customModal modal-md">
    <div class="modal-content overflow-hidden">
      <div class="modal-body p-0"
        *ngIf="approval_data && approval_data.application_data && approval_data.application_data[0] ">
        <div class="head_content text-end d-flex align-items-center justify-content-between  px-4 py-4 m-0 h5 fw-700">
          <h4 style="text-align:left;color: #000000ab;font-size: 17px;margin: 0;flex-grow: 1;text-align: center;">
            Application ID: <b style="color: black;">{{approval_data.application_id}}</b></h4>
          <!-- <span role="button_close" class="border rounded-circle" style="min-width: 45px;margin-left:10px"
            (click)="download_reciept.hide()"><img src="assets/svg/close-circle.svg" alt=""></span> -->
        </div>
        <div>
          <a (click)="download_lead_reciept()" class="download_pdf_btn">
            <button class="pdf-btn btn pointer doownload_pdf" (click)="download_reciept.hide()">
              <span><img src="assets/svg/download_icon_grey.svg"></span> Download PDF
            </button></a>
        </div>
      </div>
    </div>
  </div>
</div>